import type { TooltipProps } from '@neo4j-ndl/react';
import { IconButton, Tooltip } from '@neo4j-ndl/react';
import type { PropsWithChildren } from 'react';

interface BaseProperties {
  tipContent: string;
  testid: string;
  ariaLabel: string;
  active?: boolean;
  disabled?: boolean;
  placement?: TooltipProps['placement'];
  onClick?: () => void;
  onMouseDown?: () => void;
}

export type NvlControlButtonProps = PropsWithChildren<BaseProperties>;

export const NvlControlButton = (props: NvlControlButtonProps) => {
  const { testid, active, ariaLabel, disabled, tipContent, onClick, onMouseDown, placement, children } = props;
  return (
    <Tooltip type="simple" placement={placement}>
      <Tooltip.Trigger hasButtonWrapper>
        <IconButton
          ariaLabel={ariaLabel}
          size="medium"
          isClean
          isGrouped
          isActive={active}
          isDisabled={disabled}
          onClick={onClick}
          htmlAttributes={{
            onMouseDown,
            'data-testid': testid,
          }}
        >
          {children}
        </IconButton>
      </Tooltip.Trigger>
      <Tooltip.Content>{tipContent}</Tooltip.Content>
    </Tooltip>
  );
};
